import { logWrapper } from '../../utils';

export default {
  scriptLoaderService: [
    'runtimeConstant',
    '$q',
    '$document',
    function (runtimeConstant, $q, $document) {
      var loadedScripts = {}; // keeps track of script promises
      var loggedScripts = {}; // keeps track of which scripts have been logged

      function load(src) {
        // If already loaded or loading, return the existing promise
        if (!loadedScripts[src]) {
            var deferred = $q.defer();
            var script = $document[0].createElement('script');
            script.src = src;

            script.onload = function() {
                deferred.resolve();
                // Log only the first time
                if (!loggedScripts[src]) {
                    // eslint-disable-next-line no-console
                    console.log('Script loaded successfully:', src);
                    loggedScripts[src] = true;
                }
            };

            script.onerror = function() {
                deferred.reject('Failed to load script: ' + src);
            };

            $document[0].body.appendChild(script);
            loadedScripts[src] = deferred.promise;
        }

        return loadedScripts[src];
      }

      function run() {
        try {
          var scriptLoaderServiceFactory = {
            load: logWrapper(
              load,
              runtimeConstant.isDebugServicesInternals
            ),
          };

          return scriptLoaderServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
